import { NumberInputProps, TextInput } from 'react-admin';
import { InputAdornment } from '@mui/material';

const PercentNumberInput = (props: NumberInputProps) => {
  const { min = 0, max = 100, ...restProps } = props;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    // 科学的記数法(e)、符号(+/-)をブロック
    if (['+', '-', 'e', 'E'].includes(event.key)) {
      event.preventDefault();
    }
    // 親から渡されたonKeyDownも実行
    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
  };

  return (
    <TextInput
      type="number"
      min={min}
      max={max}
      sx={{ width: '16em' }}
      {...restProps}
      onKeyDown={handleKeyDown}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={{ '& .MuiTypography-root': { fontSize: '14px', paddingRight: '14px' } }}>
            %
          </InputAdornment>
        ),
        inputProps: {
          min: min,
          max: max,
          step: 0.01,
        }
      }}
    />
  );
};

export default PercentNumberInput;
